module.exports = __webpack_public_path__ + "img/file-----3259@1x.fb71ea4b.png";